export default __webpack_public_path__ + "static/media/PierceStgEndureIcon.85c83dcd.png";